import { useEffect, useState } from 'react';
import { supabase } from '../config/supabase';

export const useTermsAndConditions = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        setLoading(true);
        setError(null);

        console.log('🔍 Fetching terms and conditions...');
        const { data, error: fetchError } = await supabase
          .from('terms_and_conditions')
          .select('*')
          .eq('is_active', true)
          .order('section_order', { ascending: true });

        console.log('📊 Terms response:', { data, error: fetchError });

        if (fetchError) {
          console.error('❌ Terms fetch error:', fetchError);
          throw fetchError;
        }

        console.log(`✅ Loaded ${data?.length || 0} terms sections`);
        setSections(data ?? []);
      } catch (err) {
        console.error('❌ Error fetching terms and conditions:', err);
        setError(err.message || 'Failed to load terms and conditions');
        setSections([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSections();
  }, []);

  return { sections, loading, error };
};

